import { useState } from 'react';
import { Fab, Tooltip } from '@mui/material';
import { ContactSupport } from '@mui/icons-material';

import ContactSupportDialog from './ContactSupportDialog';

const ContactFab = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip title="Contacta con nosotros" placement="left">
        <Fab
          color="primary"
          size="medium"
          onClick={() => setOpen(true)}
          sx={{ position: 'fixed', bottom: 24, right: 24, zIndex: 1200 }}
          aria-label="Contacta con nosotros"
        >
          <ContactSupport sx={{ color: '#fff' }} />
        </Fab>
      </Tooltip>
      <ContactSupportDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default ContactFab;
